import { alphanumericRegex } from 'shell/constants/regex';
import * as yup from 'yup';

export const validationSchema = yup.object({
  filter: yup
    .object()
    .nullable()
    .shape({
      codeService: yup.string().nullable().matches(alphanumericRegex, 'Il campo è alfanumerico'),
      codeResponsible: yup
        .string()
        .nullable()
        .matches(alphanumericRegex, 'Il campo è alfanumerico'),
    }),
});
